'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { trackPageView } from '@/src/utils/newRelic'

interface PageTrackerProps {
  pageName?: string;
  attributes?: Record<string, any>;
}

const PageTracker: React.FC<PageTrackerProps> = ({ pageName, attributes }) => {
  const pathname = usePathname();
  
  useEffect(() => {
    // Use provided pageName or derive from pathname
    const pageNameToTrack = pageName || pathname.replace(/^\//, '').replace(/\//g, '_') || 'home';
    trackPageView(pageNameToTrack, attributes);
  }, [pathname, pageName, attributes]);
  
  return null; // This component doesn't render anything
};

export default PageTracker;